import Decimal from 'decimal.js'

// Set global precision to 28 significant digits
// This is the same value as in the backend and the default value for python
export const setDecimalConfig = () => {
  Decimal.config({ precision: 28 })
}
